import React from 'react';
import PropTypes from 'prop-types';
import useStyles from './styles';

export const LabelInput = ({ name, value, className, ...props }) => {
    const classes = useStyles();
    return (
        <React.Fragment>
            <label htmlFor={name} className={className ==='defaultLabel' ? classes.defaultLable : classes.skyLable}>{value}</label>
        </React.Fragment>
    )
}

LabelInput.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    className: PropTypes.string,
}